import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ErrorIcon from '../assets/icons/errorNotificationIcon.svg?react';
import InfoIcon from '../assets/icons/infoNotificationIcon.svg?react';
import SuccessIcon from '../assets/icons/successNotificationIcon.svg?react';
import WarningIcon from '../assets/icons/warningIcon.svg?react';
import { showToast, hideToast } from '../redux/slices/toast.slice';
import { THEME as theme } from '../styles/theme';

export interface IToastMessage {
  title: string;
  description: string;
  mode: 'warning' | 'error' | 'success' | 'information';
}
export const useToast = () => {
  const {
    toast: { toastData },
  } = useSelector((store: any) => store);
  const dispatch = useDispatch();

  const chooseToastBackgroundColor = (mode: string = 'information') => {
    switch (mode) {
      case 'information':
        return {
          border: theme.colors.support.blue[100],
          background: theme.colors.support.blue[10],
          icon: <InfoIcon />,
        };
      case 'success':
        return {
          border: theme.colors.support.green[100],
          background: theme.colors.support.green[10],
          icon: <SuccessIcon />,
        };
      case 'error':
        return {
          border: theme.colors.support.orange[100],
          background: theme.colors.support.orange[10],
          icon: <ErrorIcon />,
        };
      case 'warning':
        return {
          border: theme.colors.support.yellow[100],
          background: theme.colors.support.yellow[10],
          icon: <WarningIcon />,
        };
      default:
        return {
          border: theme.colors.support.blue[100],
          background: theme.colors.support.blue[10],
          icon: <InfoIcon />,
        };
    }
  };
  const chooseToastType = (type: string = 'floating') => {
    switch (type) {
      case 'floating':
        return {
          borderRadius: '0px 8px 8px 0px',
          borderWidth: '0 0 0 4px',
        };
      case 'static':
        return {
          borderRadius: '8px',
          borderWidth: '1px',
        };
      default:
        return {
          borderRadius: '0px 8px 8px 0px',
          borderWidth: '0 0 0 4px',
        };
    }
  };

  const showToastMessage = (message: IToastMessage) => {
    dispatch(hideToast());
    return dispatch(showToast(message));
  };

  const hideToastMessage = () => {
    return dispatch(hideToast());
  };

  useEffect(() => {
    if (!toastData) return;

    const timeoutId = window.setTimeout(() => {
      hideToastMessage();
    }, 4000);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [toastData?.title, toastData?.description]);

  return {
    toastData,
    chooseToastBackgroundColor,
    chooseToastType,
    showToastMessage,
    hideToastMessage,
  };
};
